import React from 'react';
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from '@react-google-maps/api';
import icon_map from '../../../../commons/assets/helix_map.svg';

// Icono SVG para la ubicación del usuario (punto azul)
const userLocationIcon = {
  path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
  fillColor: '#4285F4',
  fillOpacity: 1,
  strokeColor: '#ffffff',
  strokeWeight: 2,
  scale: 1.5,
  anchor: { x: 12, y: 22 },
};

function StationMap(props) {
  const mapContainerStyle = {
    height: '350px',
    width: '100%',
  };

  const center = {
    lat: parseFloat(props.center.lat),
    lng: parseFloat(props.center.lng),
  };

  const locations = props.stations.map((station) => ({
    stationId: station.id,
    lat: parseFloat(station.lat),
    lng: parseFloat(station.lng),
    title: `${station.address}`,
  }));

  const options = {
    imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
  };

  // Ubicación del usuario (punto azul)
  const userLocation = props.userLocation ? {
    lat: parseFloat(props.userLocation.lat),
    lng: parseFloat(props.userLocation.lng),
  } : null;

  // Callback cuando el mapa se carga
  const handleMapLoad = (map) => {
    if (props.onMapLoad) {
      props.onMapLoad(map);
    }
  };

  return (
    <LoadScript
      className="ml-auto mr-auto"
      id="script-loader"
      googleMapsApiKey="AIzaSyAK7dzE6LwrsMYO6Je_L_n6vQFjqsp25x8"
    >
      <GoogleMap
        id="station-map"
        mapContainerStyle={ mapContainerStyle }
        zoom={ props.zoom }
        center={ center }
        onLoad={handleMapLoad}
      >
        {/* Marcador de ubicación del usuario (punto azul) */}
        {userLocation && (
          <Marker
            position={userLocation}
            title="Tu ubicación"
            icon={userLocationIcon}
            zIndex={1000}
          />
        )}
        
        <MarkerClusterer options={ options }>
          {
            (clusterer) => locations.map((location, i) => (
              <Marker
                key={ i }
                position={ location }
                clusterer={ clusterer }
                title={ location.title }
                icon={ icon_map }
                onClick={ () => props.selectStation(
                  { value: location.stationId },
                ) }
              />
            ))
          }
        </MarkerClusterer>
      </GoogleMap>
    </LoadScript>
  );
}

export default StationMap;
